// extracted by mini-css-extract-plugin
export default {"search":"components-Search-themes-BAS-styles__search--PURCs"};